export default async function GetAttentionRequiredApi(positionId, performanceCycleId, type = 'plans', limit = 5) {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const params = new URLSearchParams({
      positionId,
      performanceCycleId,
      type,
      limit: String(limit),
    });

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/attention-required?${params}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching attention required items:", error);
    return { success: false, data: [] };
  }
}
